import React, { useEffect, useState } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import { PersonaVerification } from 'components/persona';
import { ROUTES, pathnames } from 'lib/routes';
import { useFormikContext } from 'formik';
import application from 'lib/application';

const ContactInfo = () => {
  const { values, setFieldValue, handleSubmit } = useFormikContext();
  const history = useHistory();
  const location = useLocation();
  const individual = values.individual;
  const [personaPayload, setPersonaPayload] = useState(null);

  useEffect(() => {
    if (individual.persona_inquiry_status === 'completed') {
      let nextStep = ROUTES[pathnames.contact_info].next;
      history.replace(nextStep);
    }
  }, [individual.persona_inquiry_status, history, location, values]);

  useEffect(() => {
    const getInquiryDetails = async () => {
      const result = await application.retrievePersonaInquiry();

      if (!result || result.error) {
        // no inquiry found: start new inquiry with basic embedded flow
        setPersonaPayload({
          personaAccountId: individual.persona_account_id,
          personaTemplate: 'itmpl_BNqgFT7ModB7FB5deqPZzzXc',
        });
      } else if (result) {
        // resume existing inquiry
        setPersonaPayload({
          personaAccountId: individual.persona_account_id,
          personaInquiryId: result.id,
          personaSessionToken: result.session_token,
        });
      }
    };

    if (individual.persona_inquiry_status === 'incomplete') {
      getInquiryDetails();
    }
  }, [individual.persona_account_id, individual.persona_inquiry_status]);

  const submitInquiry = (persona_inquiry_id) => {
    setFieldValue('individual.persona_inquiry_id', persona_inquiry_id);
    handleSubmit();
  };

  return (
    <Switch>
      <Route path={pathnames.contact_info}>
        <PersonaVerification
          personaPayload={personaPayload}
          handleSubmit={submitInquiry}
        />
      </Route>
    </Switch>
  );
};

export default ContactInfo;
